var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverlayImgBtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 478.394,
    height: 222.121,
    viewBox: "0 0 478.394 222.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 478.394,
    height: 222.121,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 478.394,
    height: 222.122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.769,
    height: 81.229,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.988,
    height: 18.628,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.202,
    height: 3.263,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.078,
    height: 73.341,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.949,
    height: 73.341,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.644,
    height: 21.502,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.945,
    height: 39.741,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.986,
    height: 18.628,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.989,
    height: 12.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.989,
    height: 18.628,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.566,
    height: 146.292,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.945,
    height: 73.341,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.64,
    height: 36.863,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.949,
    height: 39.741,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.986,
    height: 12.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.567,
    height: 146.292,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.645,
    height: 36.863,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.201,
    height: 3.263,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.563,
    height: 112.693,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.985,
    height: 18.628,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.563,
    height: 146.292,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.949,
    height: 73.34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.642,
    height: 36.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.645,
    height: 21.502,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.994,
    height: 4.033,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.997,
    height: 4.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.997,
    height: 4.031,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.994,
    height: 4.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.997,
    height: 4.033,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.998,
    height: 4.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.997,
    height: 4.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.998,
    height: 4.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.993,
    height: 4.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.669,
    height: 0.525,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.993,
    height: 4.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.994,
    height: 4.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.998,
    height: 4.031,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.996,
    height: 4.033,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.996,
    height: 4.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.993,
    height: 4.031,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.999,
    height: 4.031,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.993,
    height: 4.035,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cq"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.996,
    height: 4.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cw"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.999,
    height: 4.03,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.852
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.671,0H3L8.439,3.164V75.924L0,80.839v.389l8.688-5.062.081-.048V2.969Z",
    transform: "translate(0 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.61 66.708)",
    opacity: 0.967
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.021,240.478l-7.994-4.659v-9.311l7.994-4.659,7.995,4.659v9.311Zm-7.66-4.853,7.66,4.464,7.661-4.464V226.7l-7.661-4.463L2.361,226.7Z",
    transform: "translate(-2.027 -221.849)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.002)",
    opacity: 0.716
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.519,0,15.586,2.873,10.653,0H9.985l5.6,3.263L21.187,0Z",
    transform: "translate(-9.985 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.874)",
    opacity: 0.841
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,9.557,0,14.571v.385l8.6-5.01,31.141,18.14V64.369L8.6,82.509,0,77.5v.389L8.519,82.85,8.6,82.9l31.39-18.286.084-.048V27.891Z",
    transform: "translate(0 -9.557)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.744 39.352)",
    opacity: 0.994
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.652,204.213l-31.475-18.338V149.206l31.475-18.334,31.475,18.334v36.669ZM132.511,185.68l31.141,18.144,31.141-18.144V149.4l-31.141-18.14L132.511,149.4Z",
    transform: "translate(-132.177 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.744 39.352)",
    opacity: 0.939
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.652,204.213l-31.475-18.338V149.206l31.475-18.334,31.475,18.334v36.669ZM132.511,185.68l31.141,18.144,31.141-18.144V149.4l-31.141-18.14L132.511,149.4Z",
    transform: "translate(-132.177 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.618)",
    opacity: 0.977
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.763,0l-4.937,2.874L218.893,0h-.668l5.6,3.263L229.427,0Z",
    transform: "translate(-218.225 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.744 2.874)",
    opacity: 0.772
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.652,82.9l-.08-.048L132.177,64.564V27.891L163.652,9.557l31.475,18.334V64.564l-.08.048ZM132.511,64.369l31.141,18.14,31.141-18.14V28.086L163.652,9.946l-31.141,18.14Z",
    transform: "translate(-132.177 -9.557)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.618)",
    opacity: 0.634
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.763,0l-4.937,2.874L218.893,0h-.668l5.6,3.263L229.427,0Z",
    transform: "translate(-218.225 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.015)",
    opacity: 0.671
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.79,0V12.09L408.3,21.112,392.814,12.09V0h-.334V12.285L408.3,21.5l15.82-9.217V0Z",
    transform: "translate(-392.48 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.364)",
    opacity: 0.946
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.045,0V21.208L371.9,39.351,340.76,21.208V0h-.33V21.4L371.9,39.74,403.375,21.4V0Z",
    transform: "translate(-340.43 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.844 66.708)",
    opacity: 0.526
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.512,240.478l-7.995-4.659v-9.311l7.995-4.659,7.991,4.659v9.311Zm-7.66-4.853,7.66,4.464,7.66-4.464V226.7l-7.66-4.463-7.66,4.463Z",
    transform: "translate(-418.517 -221.849)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.744 2.874)",
    opacity: 0.522
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.652,82.9l-.08-.048L132.177,64.564V27.891L163.652,9.557l31.475,18.334V64.564l-.08.048ZM132.511,64.369l31.141,18.14,31.141-18.14V28.086L163.652,9.946l-31.141,18.14Z",
    transform: "translate(-132.177 -9.557)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.459)",
    opacity: 0.896
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.411,0V7.532l-7.66,4.463-7.661-4.463V0h-.334V7.726l7.995,4.659,7.995-4.659V0Z",
    transform: "translate(-626.757 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.459 66.708)",
    opacity: 0.521
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.751,240.478l-7.994-4.659v-9.311l7.994-4.659,7.995,4.659v9.311Zm-7.661-4.853,7.661,4.464,7.66-4.464V226.7l-7.66-4.463-7.661,4.463Z",
    transform: "translate(-626.757 -221.849)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.053 39.352)",
    opacity: 0.637
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.087,277.164l-.084-.047-62.7-36.526V167.445l.085-.047,62.7-36.526.08.048,62.7,36.525v73.146l-.081.051ZM236.637,240.4l62.45,36.378L361.533,240.4V167.64l-62.446-36.379-62.45,36.379Z",
    transform: "translate(-236.302 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.364 2.874)",
    opacity: 0.519
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.9,82.9l-.084-.048L340.429,64.564V27.891L371.9,9.557l31.471,18.334V64.564l-.08.048ZM340.759,64.369,371.9,82.508l31.141-18.14V28.086L371.9,9.946l-31.145,18.14Z",
    transform: "translate(-340.429 -9.557)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180.634 57.59)",
    opacity: 0.508
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.553,228.39l-15.82-9.216v-18.43l15.82-9.217,15.82,9.217v18.43Zm-15.49-9.411L616.553,228l15.485-9.022V200.935l-15.485-9.019-15.49,9.019Z",
    transform: "translate(-600.733 -191.527)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.595)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M819.526,0V21.208L788.385,39.351,757.244,21.208V0h-.334V21.4L788.385,39.74l31.394-18.286.081-.051V0Z",
    transform: "translate(-756.91 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.979 2.874)",
    opacity: 0.986
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.145,82.9l-.084-.048L548.67,64.564V27.891L580.145,9.557l31.475,18.334V64.564l-.084.048ZM549,64.369l31.141,18.14,31.141-18.14V28.086L580.145,9.946,549,28.086Z",
    transform: "translate(-548.67 -9.557)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.844)",
    opacity: 0.981
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.171,0V7.532l-7.66,4.463-7.66-4.463V0h-.335V7.726l7.995,4.659L434.5,7.726V0Z",
    transform: "translate(-418.517 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.595)",
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M819.526,0V21.208L788.385,39.351,757.244,21.208V0h-.334V21.4L788.385,39.74l31.394-18.286.081-.051V0Z",
    transform: "translate(-756.91 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.364 39.352)",
    opacity: 0.962
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.9,204.213l-31.475-18.338V149.206L371.9,130.872l31.471,18.334v36.669ZM340.759,185.68,371.9,203.824l31.141-18.144V149.4L371.9,131.261,340.759,149.4Z",
    transform: "translate(-340.429 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.364 39.352)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.9,204.213l-31.475-18.338V149.206L371.9,130.872l31.471,18.334v36.669ZM340.759,185.68,371.9,203.824l31.141-18.144V149.4L371.9,131.261,340.759,149.4Z",
    transform: "translate(-340.429 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180.634 167.02)",
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.553,592.32l-15.82-9.217V564.669l15.82-9.212,15.82,9.212V583.1Zm-15.49-9.411,15.49,9.022,15.485-9.022V564.864l-15.485-9.022-15.49,9.022Z",
    transform: "translate(-600.733 -555.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.979 148.781)",
    opacity: 0.905
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.145,568.14,548.67,549.806V513.133L580.145,494.8l31.475,18.334v36.672ZM549,549.611l31.141,18.14,31.141-18.14V513.327l-31.141-18.139L549,513.327Z",
    transform: "translate(-548.67 -494.799)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.979)",
    opacity: 0.654
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.285,0V21.208L580.144,39.351,549,21.208V0h-.334V21.4L580.144,39.74,611.619,21.4V0Z",
    transform: "translate(-548.67 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(253.468)",
    opacity: 0.957
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.495,0l-4.936,2.874L843.625,0h-.668l5.6,3.263L854.159,0Z",
    transform: "translate(-842.957 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.285 39.352)",
    opacity: 0.947
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.568,277.164l-.085-.047-62.7-36.526V167.445l.085-.047,62.7-36.526.084.048,62.7,36.525v73.146l-.084.051ZM653.117,240.4l62.45,36.378,62.45-36.378V167.64l-62.45-36.379-62.45,36.379Z",
    transform: "translate(-652.783 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.864 57.59)",
    opacity: 0.809
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1033.032,228.39l-15.82-9.216v-18.43l15.82-9.217,15.823,9.217v18.43Zm-15.486-9.411L1033.032,228l15.489-9.022V200.935l-15.489-9.019-15.486,9.019Z",
    transform: "translate(-1017.211 -191.527)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.249 167.02)",
    opacity: 0.553
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824.792,592.32l-15.82-9.217V564.669l15.82-9.212,15.82,9.212V583.1Zm-15.486-9.411,15.486,9.022,15.486-9.022V564.864l-15.486-9.022-15.486,9.022Z",
    transform: "translate(-808.972 -555.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(316.085)",
    opacity: 0.954
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1061.735,0,1056.8,2.873,1051.865,0h-.667l5.6,3.263L1062.4,0Z",
    transform: "translate(-1051.198 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.829)",
    opacity: 0.875
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1236.015,0V21.208l-31.141,18.143-31.14-18.143V0h-.334V21.4l31.475,18.338L1236.35,21.4V0Z",
    transform: "translate(-1173.4 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.595)",
    opacity: 0.505
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M819.526,0V21.208L788.385,39.351,757.244,21.208V0h-.334V21.4L788.385,39.74l31.394-18.286.081-.051V0Z",
    transform: "translate(-756.91 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.904)",
    opacity: 0.852
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M980.833,0l5.433,3.164V75.924L923.815,112.3l-62.45-36.379V3.164L866.8,0h-.665l-5.022,2.922-.081.047v73.15l62.7,36.526.081.047,62.7-36.525.085-.048V2.969L981.5,0Z",
    transform: "translate(-861.034 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(376.31 66.708)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1259.484,240.478l-7.994-4.659v-9.311l7.994-4.659,7.991,4.659v9.311Zm-7.66-4.853,7.66,4.464,7.661-4.464V226.7l-7.661-4.463-7.66,4.463Z",
    transform: "translate(-1251.49 -221.849)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.595 39.352)",
    opacity: 0.618
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.385,204.213,756.91,185.875V149.206l31.475-18.334.084.048,31.391,18.286v36.669l-.081.051ZM757.244,185.68l31.141,18.144,31.141-18.144V149.4l-31.141-18.14L757.244,149.4Z",
    transform: "translate(-756.91 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.904 39.352)",
    opacity: 0.876
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M923.816,277.164l-.081-.047-62.7-36.526V167.445l.081-.047,62.7-36.526.084.048,62.7,36.525v73.146l-.084.051ZM861.366,240.4l62.45,36.378,62.45-36.378V167.64l-62.45-36.379-62.45,36.379Z",
    transform: "translate(-861.035 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.864 167.02)",
    opacity: 0.585
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1033.032,592.32l-15.82-9.217V564.669l15.82-9.212,15.823,9.212V583.1Zm-15.486-9.411,15.486,9.022,15.489-9.022V564.864l-15.489-9.022-15.486,9.022Z",
    transform: "translate(-1017.211 -555.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.595 112.304)",
    opacity: 0.543
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.385,446.827l-.085-.047-31.39-18.287V391.82l31.475-18.334.084.048,31.391,18.286v36.672l-.081.048ZM757.244,428.3l31.141,18.139L819.526,428.3V392.014l-31.141-18.14-31.141,18.14Z",
    transform: "translate(-756.91 -373.486)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.444)",
    opacity: 0.847
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1444.259,0V21.208l-31.145,18.143-31.14-18.143V0h-.334V21.4l31.474,18.338L1444.589,21.4V0Z",
    transform: "translate(-1381.64 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.483 21.113)",
    opacity: 0.777
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1241.284,107.081l-15.82-9.22V79.431l15.82-9.217,15.82,9.217V97.86Zm-15.489-9.415,15.489,9.026,15.486-9.026V79.625L1241.284,70.6l-15.489,9.022Z",
    transform: "translate(-1225.463 -70.214)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(378.703)",
    opacity: 0.619
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1269.982,0l-4.933,2.874L1260.112,0h-.665l5.6,3.263L1270.65,0Z",
    transform: "translate(-1259.448 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.098)",
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1465.008,0V12.09l-15.486,9.022-15.486-9.022V0h-.334V12.285l15.82,9.217,15.824-9.217V0Z",
    transform: "translate(-1433.701 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.444)",
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1444.259,0V21.208l-31.145,18.143-31.14-18.143V0h-.334V21.4l31.474,18.338L1444.589,21.4V0Z",
    transform: "translate(-1381.64 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.21 39.352)",
    opacity: 0.951
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.625,204.213,965.15,185.875V149.206l31.475-18.334.084.048,31.39,18.286v36.669l-.081.051ZM965.484,185.68l31.141,18.144,31.144-18.144V149.4l-31.144-18.14L965.484,149.4Z",
    transform: "translate(-965.15 -130.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.444 112.304)",
    opacity: 0.626
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.115,446.827l-.084-.047-31.39-18.287V391.82l31.475-18.334,31.475,18.334v36.672l-.081.048Zm-31.14-18.528,31.14,18.139,31.145-18.139V392.014l-31.145-18.14-31.14,18.14Z",
    transform: "translate(-1381.64 -373.486)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.21 112.304)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.625,446.827l-.081-.047L965.15,428.492V391.82l31.475-18.334.084.048,31.39,18.286v36.672l-.081.048ZM965.484,428.3l31.141,18.139,31.144-18.139V392.014l-31.144-18.14-31.141,18.14Z",
    transform: "translate(-965.15 -373.486)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.607 83.123)",
    opacity: 0.687
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.966,278.458a2,2,0,1,1-2-2.019,2.005,2.005,0,0,1,2,2.019",
    transform: "translate(-21.972 -276.439)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.913 55.767)",
    opacity: 0.975
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.085,187.48a2,2,0,1,1-2-2.019,2.007,2.007,0,0,1,2,2.019",
    transform: "translate(-126.088 -185.461)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.222 1.053)",
    opacity: 0.906
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.21,5.517a2,2,0,1,1-2-2.016,2.008,2.008,0,0,1,2,2.016",
    transform: "translate(-230.213 -3.501)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.222 74.005)",
    opacity: 0.862
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.21,248.132a2,2,0,1,1-2-2.015,2.006,2.006,0,0,1,2,2.015",
    transform: "translate(-230.213 -246.117)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.183 10.171)",
    opacity: 0.725
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.386,35.843a2,2,0,1,1-2-2.019,2.007,2.007,0,0,1,2,2.019",
    transform: "translate(-386.389 -33.824)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.493 10.171)",
    opacity: 0.544
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.511,35.843a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-490.514 -33.824)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.532 19.293)",
    opacity: 0.856
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.331,66.175a2,2,0,1,1-2-2.016,2.005,2.005,0,0,1,2,2.016",
    transform: "translate(-334.337 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.838 83.123)",
    opacity: 0.691
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.449,278.458a2,2,0,1,1-2-2.019,2.007,2.007,0,0,1,2,2.019",
    transform: "translate(-438.452 -276.439)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.222 74.005)",
    opacity: 0.617
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.21,248.132a2,2,0,1,1-2-2.015,2.006,2.006,0,0,1,2,2.015",
    transform: "translate(-230.213 -246.117)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.528 55.767)",
    opacity: 0.512
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.323,187.48a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-334.325 -185.461)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.453 10.171)",
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.689,35.843a2,2,0,1,1-2-2.019,2.007,2.007,0,0,1,2,2.019",
    transform: "translate(-646.692 -33.824)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.283 69.447)",
    opacity: 0.663
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.727,232.972a2,2,0,1,1-2-2.015,2.008,2.008,0,0,1,2,2.015",
    transform: "translate(-672.73 -230.957)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.838 183.435)",
    opacity: 0.664
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.449,612.062a2,2,0,1,1-2-2.015,2.007,2.007,0,0,1,2,2.015",
    transform: "translate(-438.452 -610.047)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.453 146.961)",
    opacity: 0.954
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.689,490.76a2,2,0,1,1-2-2.015,2.007,2.007,0,0,1,2,2.015",
    transform: "translate(-646.692 -488.745)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.222 74.005)",
    opacity: 0.641
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.21,248.132a2,2,0,1,1-2-2.015,2.006,2.006,0,0,1,2,2.015",
    transform: "translate(-230.213 -246.117)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.838 74.005)",
    opacity: 0.525
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.449,248.132a2,2,0,1,1-2-2.015,2.006,2.006,0,0,1,2,2.015",
    transform: "translate(-438.452 -246.117)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.147 55.767)",
    opacity: 0.761
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.575,187.48a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-542.577 -185.461)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.147 19.293)",
    opacity: 0.617
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.575,66.175a2,2,0,1,1-2-2.016,2.008,2.008,0,0,1,2,2.016",
    transform: "translate(-542.577 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.108 64.888)",
    opacity: 0.503
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.751,217.81a2,2,0,1,1-2-2.015,2.008,2.008,0,0,1,2,2.015",
    transform: "translate(-698.754 -215.795)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.382 19.293)",
    opacity: 0.907
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.063,66.175a2,2,0,1,1-2-2.016,2.007,2.007,0,0,1,2,2.016",
    transform: "translate(-959.07 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.676)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.635,0a1.966,1.966,0,0,0,1.333.525A1.975,1.975,0,0,0,417.3,0Z",
    transform: "translate(-414.635 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.073 37.528)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.938,126.823a2,2,0,1,1-2-2.019,2,2,0,0,1,2,2.019",
    transform: "translate(-854.945 -124.804)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.147 55.767)",
    opacity: 0.661
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.575,187.48a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-542.577 -185.461)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.108 192.556)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.751,642.4a2,2,0,1,1-2-2.015,2.007,2.007,0,0,1,2,2.015",
    transform: "translate(-698.754 -640.38)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.453 165.196)",
    opacity: 0.928
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.689,551.405a2,2,0,1,1-2-2.015,2.008,2.008,0,0,1,2,2.015",
    transform: "translate(-646.692 -549.39)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.802 174.314)",
    opacity: 0.633
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.633,581.73a2,2,0,1,1-2-2.018,2.005,2.005,0,0,1,2,2.018",
    transform: "translate(-594.639 -579.712)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.147 201.673)",
    opacity: 0.694
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.575,672.717a2,2,0,1,1-2-2.015,2.009,2.009,0,0,1,2,2.015",
    transform: "translate(-542.577 -670.702)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.453 37.528)",
    opacity: 0.771
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.689,126.823a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-646.692 -124.804)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.763 19.293)",
    opacity: 0.843
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.815,66.175a2,2,0,1,1-2-2.016,2.009,2.009,0,0,1,2,2.016",
    transform: "translate(-750.817 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.344 83.123)",
    opacity: 0.992
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.245,278.458a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-1115.249 -276.439)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.344 64.888)",
    opacity: 0.961
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.245,217.81a2,2,0,1,1-2-2.015,2.008,2.008,0,0,1,2,2.015",
    transform: "translate(-1115.249 -215.795)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.613 19.293)",
    opacity: 0.684
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1379.547,66.175a2,2,0,1,1-2-2.016,2.008,2.008,0,0,1,2,2.016",
    transform: "translate(-1375.55 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.763 19.293)",
    opacity: 0.909
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.815,66.175a2,2,0,1,1-2-2.016,2.008,2.008,0,0,1,2,2.016",
    transform: "translate(-750.817 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.382 19.293)",
    opacity: 0.725
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.063,66.175a2,2,0,1,1-2-2.016,2.007,2.007,0,0,1,2,2.016",
    transform: "translate(-959.07 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.073 74.005)",
    opacity: 0.522
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.938,248.132a2,2,0,1,1-2-2.015,2,2,0,0,1,2,2.015",
    transform: "translate(-854.945 -246.117)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.073 1.053)",
    opacity: 0.758
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.938,5.517a2,2,0,1,1-2-2.016,2,2,0,0,1,2,2.016",
    transform: "translate(-854.945 -3.501)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.479 78.564)",
    opacity: 0.567
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1249.395,263.3a2,2,0,1,1-2-2.018,2.009,2.009,0,0,1,2,2.018",
    transform: "translate(-1245.398 -261.28)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.132 69.447)",
    opacity: 0.664
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1301.458,232.972a2,2,0,1,1-2-2.015,2.008,2.008,0,0,1,2,2.015",
    transform: "translate(-1297.46 -230.957)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.306 64.888)",
    opacity: 0.784
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275.429,217.81a2,2,0,1,1-2-2.015,2.008,2.008,0,0,1,2,2.015",
    transform: "translate(-1271.434 -215.795)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.687 201.673)",
    opacity: 0.869
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1067.18,672.717a2,2,0,1,1-2-2.015,2.009,2.009,0,0,1,2,2.015",
    transform: "translate(-1063.181 -670.702)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.382 128.718)",
    opacity: 0.944
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.063,430.093a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-959.07 -428.074)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.073 110.483)",
    opacity: 0.849
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M858.938,369.447a2,2,0,1,1-2-2.015,2,2,0,0,1,2,2.015",
    transform: "translate(-854.945 -367.432)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.613 19.293)",
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1379.547,66.175a2,2,0,1,1-2-2.016,2.007,2.007,0,0,1,2,2.016",
    transform: "translate(-1375.55 -64.159)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(444.924 37.528)",
    opacity: 0.865
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1483.669,126.823a2,2,0,1,1-2-2.019,2.006,2.006,0,0,1,2,2.019",
    transform: "translate(-1479.677 -124.804)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.306 55.767)",
    opacity: 0.531
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275.429,187.48a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-1271.434 -185.461)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(429.267 10.171)",
    opacity: 0.723
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1431.61,35.843a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-1427.612 -33.824)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(460.578 10.171)",
    opacity: 0.588
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1535.732,35.843a2,2,0,1,1-2-2.019,2.008,2.008,0,0,1,2,2.019",
    transform: "translate(-1531.739 -33.824)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.382 92.244)",
    opacity: 0.886
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.063,308.79a2,2,0,1,1-2-2.015,2.007,2.007,0,0,1,2,2.015",
    transform: "translate(-959.07 -306.775)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.998 92.244)",
    opacity: 0.588
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1171.3,308.79a2,2,0,1,1-2-2.015,2,2,0,0,1,2,2.015",
    transform: "translate(-1167.31 -306.775)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(444.924 110.483)",
    opacity: 0.975
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1483.669,369.447a2,2,0,1,1-2-2.015,2.006,2.006,0,0,1,2,2.015",
    transform: "translate(-1479.677 -367.432)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.687 183.435)",
    opacity: 0.668
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1067.18,612.062a2,2,0,1,1-2-2.015,2.008,2.008,0,0,1,2,2.015",
    transform: "translate(-1063.181 -610.047)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.687 110.483)",
    opacity: 0.779
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1067.18,369.447a2,2,0,1,1-2-2.015,2.009,2.009,0,0,1,2,2.015",
    transform: "translate(-1063.181 -367.432)",
    fill: "#808285"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayImgBtm);
export default __webpack_public_path__ + "static/media/overlay_img_btm.c1c503ab26d17101082c1077b6e889ce.svg";
export { ForwardRef as ReactComponent };